import React from 'react'
import { DoorPlane } from './DoorPlane'
import { Cube } from '../../../geometries/Cube'

export const LeftPart = ({ position = [0, 0, 0], rotation = [0, 0, 0], scale = [1, 1, 1], color }) => {
	return (
		<group position={position} scale={scale} rotation={rotation} castShadow receiveShadow>
			<Cube color={color} position={[0, 50, 0]} size={[5, 5, 35]} />
			<Cube color={color} position={[0, 25, -15]} size={[5, 50, 5]} />
			<DoorPlane isLeft />
		</group>
	)
}
